import { Link } from "react-router-dom";

interface SiteLogoProps {
  variant?: "default" | "light";
}

export default function SiteLogo({ variant = "default" }: SiteLogoProps) {
  const textColor = variant === "light" ? "text-background-50" : "text-foreground-950";
  const subColor = variant === "light" ? "text-background-100/80" : "text-secondary-500";

  return (
    <Link to="/" className="flex items-center gap-2.5 cursor-pointer shrink-0" aria-label="最近最新手机中文大全10 首页">
      <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-primary-500 text-background-50 shrink-0">
        <i className="ri-smartphone-line text-xl" aria-hidden="true"></i>
      </span>
      <span className="flex flex-col leading-none">
        <span className={`font-heading text-[15px] font-bold tracking-tight whitespace-nowrap ${textColor}`}>
          手机中文大全<span className="text-accent-500">10</span>
        </span>
        <span className={`text-[10px] mt-0.5 whitespace-nowrap ${subColor}`}>手机软件合集与最新版本下载</span>
      </span>
    </Link>
  );
}